import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface SetFunctionalLocationFromCsvResult {
  updated: number;
  ruleNotFound: number;
  skippedFunctionalLocationNotFound: { ruleUid: string; sapId: string }[];
  summary: string;
}

export interface ImportLabelsFromCsvResult {
  workCenterLabelsCreated: number;
  ruleToWorkCenterLabelsCreated: number;
  errors: { rowNumber: number; reason: string; rawData: string }[];
  summary: string;
}

@Injectable({
  providedIn: 'root',
})
export class MigrationService {
  constructor(private apiService: ApiService) {}

  setRuleFunctionalLocationFromCsv(
    file: File,
  ): Observable<SetFunctionalLocationFromCsvResult> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postFormData<SetFunctionalLocationFromCsvResult>(
      '/Migration/set-rule-functional-location-from-csv/',
      formData,
      true,
    );
  }

  importLabelsFromCsv(file: File): Observable<ImportLabelsFromCsvResult> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postFormData<ImportLabelsFromCsvResult>(
      '/Migration/import-labels-from-csv/',
      formData,
      true,
    );
  }
}
